module.exports = __webpack_public_path__ + "static/img/environment_01_h5.fd2b9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_01_h5.png
// module id = KaXm
// module chunks = 34